import { environment } from "@orderna/admin-panel/src/environments/environment";

export const ACCOUNTING_ANALYTICS_API_URL = `${environment.api}/analytics/accounting`;

export const ANALYTICS_API_URL = `${environment.api}/analytics/`;
